export default class Locale_WorkPackageSelector {
	IncludeAnotherPackage: string = "Include another template";
	IncludeAnotherWorkPackage: string = "Include another request template";
}